<div class="cdp-warn-chip-container" [ngStyle]="{ 'margin-left': isBulkEdit ? '-6px' : '20px' }">
    <hc-chip color="yellow" width="99%">
        <div class="cdp-warn-message-container">
            <hc-icon class="icon-warn" hcIconSm></hc-icon>
            <div>
                <span>{{ message }}</span> {{ checkIfIntentionalMessage }}
            </div>
            <span *ngIf="isBulkEdit" class="icon-info cdp-info-ico" [hcTooltip]="infoMessage"></span>
        </div>
    </hc-chip>
</div>
